import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class LoaderComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Input()
  id: string;

  _message: BehaviorSubject<string> = new BehaviorSubject<string>('');
  $message: Observable<string>;
  messageSub: Subscription;

  @Input()
  delay = 0;

  @Input()
  formField = false;

  display = false;

  constructor(private readonly translateService: TranslateService) {
    this.$message = this._message.asObservable();
  }

  ngOnInit() {
    if (this.delay) {
      const id = setTimeout(() => {
        this.display = true;
      }, this.delay);
      this.destroyRef.onDestroy(() => clearTimeout(id));
    } else {
      this.display = true;
    }
  }

  @Input()
  set messageKey(k: string) {
    this.messageSub?.unsubscribe();

    if (k) {
      // Dans implicit/callback on a une traduction vide si on fait service.instant 😕
      this.messageSub = this.translateService.get(k).subscribe((translated) => this._message.next(translated));
    }
  }

  @Input()
  set message(m: string) {
    console.log(`Translated message: ${m}`);
    this._message.next(m);
  }
}
